// Custom drag MIME type encodes the source contract id in the type string itself
// (rather than in the payload) because dataTransfer.getData() only returns real
// data on "drop" - during "dragover" only dataTransfer.types is readable, and
// that's what a drop target needs to decide whether to allow the drop.
const CYCLE_DRAG_PREFIX = 'application/x-heatview-cycle:';

export type CycleDragPayload = {
  cycleId: string;
  // The screen the cycle is being dragged FROM, or null if it was screenless.
  // Needed so the drop target can also refresh the source's cycle list -
  // otherwise the source keeps showing its stale local copy until its next poll,
  // which looks like the cycle was duplicated instead of moved.
  sourceScreenId: string | null;
};

export const setCycleDragPayload = (
  event: React.DragEvent,
  cycleId: string,
  contractId: string,
  sourceScreenId: string | null,
): void => {
  const payload: CycleDragPayload = { cycleId, sourceScreenId };
  event.dataTransfer.setData(`${CYCLE_DRAG_PREFIX}${contractId.toLowerCase()}`, JSON.stringify(payload));
  event.dataTransfer.effectAllowed = 'move';
};

export const isCycleDragForContract = (event: React.DragEvent, contractId: string): boolean => {
  if (!contractId) return false;
  const type = `${CYCLE_DRAG_PREFIX}${contractId.toLowerCase()}`;
  return event.dataTransfer.types.includes(type);
};

export const readCycleDragPayload = (event: React.DragEvent, contractId: string): CycleDragPayload | null => {
  if (!contractId) return null;
  const raw = event.dataTransfer.getData(`${CYCLE_DRAG_PREFIX}${contractId.toLowerCase()}`);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CycleDragPayload;
  } catch {
    return null;
  }
};
